/** Matches GameRules::MAX_BENCH_SIZE on the server. */
export const MAX_BENCH_SIZE = 5;

/** Each player sets aside six prize cards. */
export const PRIZE_COUNT = 6;

export const BENCH_POSITIONS = Array.from({ length: MAX_BENCH_SIZE }, (_, i) => i);
export const PRIZE_POSITIONS = Array.from({ length: PRIZE_COUNT }, (_, i) => i);

/** The playmat photo, public/image/gamemap.jpg, is 2000×2078. */
export const MAT_ASPECT = 2000 / 2078;

/** A card on the mat is as wide as the mat's printed prize boxes: 9.6% of the mat. */
export const MAT_CARD_WIDTH = 9.6;

/**
 * Where each spot's top-left corner sits on the mat, as [left, top] in % of the mat's width and height, for a
 * player's own half, with that half at the bottom. The mat is printed the same both ways round, so the opponent's
 * half uses the same spots turned 180°. Measured off the photo.
 *
 * The one exception is the active Pokémon: both actives sit a little below the middle of the screen rather than
 * mirrored about it, so the opponent's has its own spot (in their turned-around half, a smaller top is lower on
 * your screen).
 */
export const MAT_SPOTS = {
  prizes: [[4.95, 56.4], [15.7, 56.4], [4.95, 70.35], [15.7, 70.35], [4.95, 84.55], [15.7, 84.55]],
  active: [45.2, 54],
  opponentActive: [45.2, 49],
  bench: [[26.95, 73.8], [38.45, 73.8], [49.7, 73.8], [61.15, 73.8], [72.3, 73.8]],
  deck: [83.85, 62.25],
  discard: [84.3, 77],
};
